/** @param {HTMLElement} button */
export const revealOptionalField = (button) => {
    const container = button.closest('[data-optional-fields]');
    const field     = container.querySelector(`[data-optional-field="${button.dataset.revealOptionalField}"]`);

    field.hidden  = false;
    button.hidden = true;

    field.querySelector('input')?.focus();

    const links = container.querySelector('[data-optional-field-links]');

    if (!links.querySelector('[data-reveal-optional-field]:not([hidden])')) {
        links.hidden = true;
    }
};
